module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/tryouts"
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tryout-groups"
    }
  }, [_vm._v("Tryout Group")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/serial"
    }
  }, [_vm._v("Tryout Serial")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tryout-regrading"
    }
  }, [_vm._v("Regrading Tryout")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('span', [_vm._v("Tryout")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ef9cee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout_group/Navigation.vue
// module id = 1345
// module chunks = 0